import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { _ } from 'vue-underscore';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Daftar Pembelian',
    title_form: 'Order Pembelian',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Pembelian',
        href: '/adm/logistic/pembelian',
        active: true,
      },
    ],
    tab: [
      {
        name: 'Supplier',
        active: true,
      },
      {
        name: 'Kode Akun dan HPP',
        active: false,
      },
    ],
    formProduct: {
      name: '',
      stock: '',
      min_stock: '',
      unit: '',
      price_buy: '',
      price_sale: '',
      brand: '',
      supplier_product: [
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
      ],
    },
    items: [
      {
        id: 1,
        kode: 'PO00121090001',
        supplier: 'PT AMERTA INDAH JAYA',
        tgl_beli: '2021-09-01',
        tgl_antar: '2021-09-01',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        status: 'not paid',
        jenis: 'produk',
        terima: 'complete',
      },
      {
        id: 2,
        kode: 'PO00121090002',
        supplier: 'PT SEJAHTERA JAYA',
        tgl_beli: '2021-09-01',
        tgl_antar: '2021-09-01',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        status: 'paid',
        jenis: 'produk',
        terima: 'on delivery',
      },
      {
        id: 3,
        kode: 'PO00121090003',
        supplier: 'PT TIRTA JAYA',
        tgl_beli: '2021-09-01',
        tgl_antar: '2021-09-01',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        status: 'paid',
        jenis: 'jasa',
      },
    ],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'supplier',
        label: 'Supplier',
        sortable: true,
      },
      {
        key: 'tgl_beli',
        label: 'Tgl Beli',
      },
      {
        key: 'tgl_antar',
        label: 'Tgl Antar',
      },
      {
        key: 'jenis',
        label: 'Jenis',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'terima',
        label: 'Terima',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
  },
};

export const getters = {
  form(state) {
    return state.data.formProduct;
  },
  activeTab(state) {
    let tabActive = _.findWhere(state.data.tab, {
      active: true,
    });

    return tabActive ? tabActive.name : '';
  },
};

export const mutations = {
  changePembelian(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCustomer(context, params = null) {
    let result = await ApiGetRequest(`logistic/suppliers`, params);
    return !result.error ? result.data.object : [];
  },

  async getListCustomer({ commit, state }) {
    commit('changePembelian', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      _limit: data.limit,
      _page: data.page,
      _sort: data.sortBy,
      _order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/suppliers`, params);
    commit('changePembelian', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailCustomer({ commit }, payload = null) {
    commit('changePembelian', {
      loading: true,
    });

    let result = await ApiGetRequest(`logistic/suppliers/${payload.id}`);
    commit('changePembelian', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createCustomer({ commit, state, dispatch }) {
    commit('changePembelian', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/suppliers`, state.data.form);
    commit('changePembelian', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomer({ commit, state, dispatch }, payload = null) {
    commit('changePembelian', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/suppliers/${payload.id}`,
      state.data.form
    );

    commit('changePembelian', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomer({ commit, dispatch }, payload = null) {
    commit('changePembelian', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/suppliers/${payload.id}`);
    commit('changePembelian', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
